/*
 * ******************************************************************************
 * AUTORIZACIÓN Y ASUNTOS DE USUARIOS.                                          *
 * ******************************************************************************
 */
import Console from '@/shared/console';

/**
 * Getter para obtener el LangCode del state.
 */
export const langCode = function (state) {
  return state.langCode;
};
/**
 * Getter para comprobar si se han cargado las traducciones.
 */
export const getTranslationIsLoaded = function (state) {
  return state.translationIsLoaded;
};
/**
 * Getter para comprobar si se visualiza la app.
 */
export const getShowApp = function (state) {
  return state.showApp;
};

/**
 * Getter para obtener las configuraciones basicas del usuario del state.
 */
export const userSettings = function (state) {
  return state.userSettings;
};

/**
 * Getter para obtener las configuraciones basicas del usuario del state.
 */
export const currency = function (state) {
  return state.userSettings?.Currency ?? 'USD';
};

//Retornar default item combo
export const comboDefaultIItem = function (state) {
  return state.comboDefaultIItem;
};

/**
 * Getter para obtener el estado de cadauno de los componentes
 */
export const getComponentsActivation = function (state) {
  return state.componentsActivation;
};

/**
 * Getter para obtener el formato de fechas del usuario.
 */
export const userDateFormat = function (state, getters) {
  const userSelectedDateFormat = state.userSettings?.DateFormat;
  const dateFormatParamList = getters['paramListModule/getParamListEnumByParamId'](885);
  if (userSelectedDateFormat) {
    return dateFormatParamList?.find(({ ValueCode }) => ValueCode === userSelectedDateFormat)?.ValueDesc ?? null;
  } else {
    Console.warn('There is no user date format selected');
    return 'DD/MM/YYYY';
  }
};

/**
 * Getter para obtener el separador de miles según la instancia.
 * TODO refactor para recibirlo de la configuración de usuario.
 */
export const thousandsSeparator = function (state, getters, rootState, rootGetters) {
  const separatorByInstance = {
    INSTANCE_UK: ',',
    INSTANCE_CA: ',',
    INSTANCE_US: ' ',
  };

  return separatorByInstance[rootGetters['authModule/fullInstance']] ?? ' ';
};

/**
 * Getter para obtener el texto que se muestra en caso de no tener valor.
 * TODO refactor para recibirlo de la configuración de usuario.
 */
export const fallbackText = function (state, getters, rootState, rootGetters) {
  const defaultFallbackText = '—';

  const dic = { INSTANCE_UK: '' };

  return dic[rootGetters['authModule/fullInstance']] ?? defaultFallbackText;
};

/**
 * Getter para obtener el formato de fechas que utilizan servicios de backend.
 */
export const backendDateFormat = function () {
  return 'YYYY-MM-DD';
};

/**
 * Getter para obtener el modo de la vista de pestañas, entre research o property (modes.js)
 */
export const getMode = function (state) {
  return state.mode;
};
